import { render, staticRenderFns } from "./_feeList.vue?vue&type=template&id=dde5f1ea"
import script from "./_feeList.vue?vue&type=script&lang=js"
export * from "./_feeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports